// import React, { createContext, useState, useMemo } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { getTheme } from "../theme";

// export const ThemeContext = createContext();

// export const ThemeContextProvider = ({ children }) => {
//   const [mode, setMode] = useState(localStorage.getItem("themeMode") || "dark");

//   const toggleTheme = () => {
//     const newMode = mode === "dark" ? "light" : "dark";
//     setMode(newMode);
//     localStorage.setItem("themeMode", newMode);
//   };

//   const theme = useMemo(() => getTheme(mode), [mode]);

//   return (
//     <ThemeContext.Provider value={{ mode, toggleTheme }}>
//       <ThemeProvider theme={theme}>{children}</ThemeProvider>
//     </ThemeContext.Provider>
//   );
// };
import React, { createContext, useState, useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { getTheme } from "../theme";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const [mode, setMode] = useState(localStorage.getItem("themeMode") || "dark");

  const toggleTheme = () => {
    const newMode = mode === "dark" ? "light" : "dark";
    setMode(newMode);
    localStorage.setItem("themeMode", newMode);
  };

  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
